import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IGeneralStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IGeneralStatsResponse>,
  IPathBaseParam,
  object
>("generalStats");

export const generalStats = {
  ...getApis,
};
